import React from 'react';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';
import BackButton from '../../components/buttons/BackButton';

const PopUp = props => {
  const {
    children,
    title,
    popupName,
    noButtons,
    buttons,
    buttonText,
    additionalFunc,
    noButton,
    show,
  } = props;

  const closePopup = e => {
    const popup = e.target.closest(`[data-popup-name="${popupName}"]`);
    popup.classList.remove('open');
    if (additionalFunc !== undefined) {
      additionalFunc();
    }
  };

  return (
    <div className={`${show ? 'pop-up open' : ''} pop-up`} data-popup-name={popupName}>
      <div className="pop-up__box">
        {!noButtons && <BackButton title={title} click={closePopup} />}
        {children}
        {!noButtons && (
          <div className="container pop-up__buttons">
            {buttons &&
              buttons.map((key, index) => (
                <Button
                  link="/wardrobe-body-configuration"
                  text={buttons[index].text}
                  key={index}
                  click={buttons[index].action}
                  color={buttons[index].hasOwnProperty('color') ? buttons[index].color : ''}
                />
              ))}
            {noButton ? null : additionalFunc !== undefined ? (
              <Button
                link="/wardrobe-body-configuration"
                text={buttonText ? buttonText : 'wróć'}
                click={closePopup}
              />
            ) : (
              <Button text={buttonText ? buttonText : 'wróć'} click={closePopup} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

PopUp.propTypes = {
  popupName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  noButton: PropTypes.bool,
  buttons: PropTypes.array,
  buttonText: PropTypes.string,
  additionalFunc: PropTypes.func,
  show: PropTypes.bool,
};

PopUp.defaultProps = {
  show: false,
};

export default PopUp;
